






















































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { TableExpandWithAccordionDecorator } from "@root/utils/modules/wtRecord/decorator";
import CustomTableScrollWrap from "@/components/custom/CustomTableScrollWrap/index.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const Root = namespace("root");
const wtK2Scan = namespace("scan");
const exportFile = namespace("export");
const k2Coupon = namespace("k2Coupon");
@Component({ components: { CustomTableScrollWrap } })
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
@TableExpandWithAccordionDecorator()
export default class wtK2Warehousing extends Vue {
  @Root.State ddCodes;
  @k2Coupon.Action queryCouponBaseInfoList;
  @exportFile.Action exportStoreScanRecordByUpdateTime;
  @exportFile.Action exportStoreScanRecord;
  @wtK2Scan.Action queryStoreScanRecord;
  @wtK2Scan.Action updateStoreRecordStatus;
  @wtK2Scan.State marketList;
  @wtK2Scan.State inOutStatusList;
  @wtK2Scan.Getter marketListObj;
  @wtK2Scan.Getter inOutStatusListObj;
  @wtK2Scan.State isK1Obj;
  @wtK2Scan.State storeAreaObj;
  @wtK2Scan.State takeEffectObj;
  @wtK2Scan.Action queryInoutInventory;
  // @wtK2Scan.State systemTypeObj;

  private isKaOptions: any[] = [];
  private form = {
    recordCode: "",
    orgCode: "",
    tyreCode: "",
    ownerMobile: "",
    marketType: "",
    status: undefined,
    updateDateTime: "",
    time: "",
    isKa: "",
    recordType: 2
  };
  private dataList = [];

  private searchData = {
    recordType: 2
  };
  private isExportVisible = false;
  private total = 0;
  private couponDialogVisible = false;
  private couponDialogLoading = false;
  private couponDialogData = [];
  private couponDialogCurrentPage = 1;
  private couponDialogPageSize = 50;
  async mounted() {
    // await this.getData();
  }
  async created() {
    await this.$dd.register(["SEVEN_DAY", "isKA"]).query();
    this.isKaOptions = this.ddCodes["isKA"] || [];
    this.queryInoutInventory();
  }

  get couponDialogPageList() {
    const start =
      (this.couponDialogCurrentPage - 1) * this.couponDialogPageSize;
    return this.couponDialogData.slice(
      start,
      start + this.couponDialogPageSize
    );
  }

  async openCouponDialog(row) {
    const couponCodeList = Array.from(new Set(row.rewardCouponCodeList || []));
    this.couponDialogVisible = true;
    this.couponDialogCurrentPage = 1;
    this.couponDialogData = [];
    if (!couponCodeList.length) return;

    this.couponDialogLoading = true;
    try {
      this.couponDialogData = await this.queryCouponBaseInfoList({
        couponCodeList
      });
    } catch (err) {
      this.$message.error("优惠券详情获取失败");
    } finally {
      this.couponDialogLoading = false;
    }
  }

  handleCouponPageChange(page) {
    this.couponDialogCurrentPage = page;
  }

  handleCouponPageSizeChange(pageSize) {
    this.couponDialogPageSize = pageSize;
    this.couponDialogCurrentPage = 1;
  }

  resetCouponDialog() {
    this.couponDialogData = [];
    this.couponDialogCurrentPage = 1;
    this.couponDialogPageSize = 50;
    this.couponDialogLoading = false;
  }

  get searchParams() {
    let { time, updateDateTime, ...others } = this.form;
    let start = undefined;
    let end = undefined;
    if (time) {
      start = time[0];
      end = time[1];
    }
    let startUpdate = undefined;
    let endUpdate = undefined;
    if (updateDateTime) {
      startUpdate = updateDateTime[0];
      endUpdate = updateDateTime[1];
    }

    let input = {
      ...others,
      isKa: others.isKa === "" ? null : others.isKa,
      startTime: start || undefined,
      endTime: end || undefined,
      updateStartTime: startUpdate || undefined,
      updateEndTime: endUpdate || undefined
    };
    return input;
  }
  @loadingCatch
  async getData() {
    (this as any).expandKeys = [];
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    try {
      let input = this.searchParams;
      await this.timeLimitFn();
      let { total, list } = await this.queryStoreScanRecord({
        input,
        pageInput
      });
      this.dataList = list.map(row => {
        this.$set(row, "status", row.status);
        return row;
      });
      this.total = total;
    } catch (err) {
      console.error(err);
      this.total = 0;
    }
  }
  async confirmRecord(row) {
    await this.$confirm("你确定通过这条记录吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
    await this.updateStoreRecordStatus({
      scanStoreUpdateInput: {
        recordCode: row.recordCode,
        orgCode: row.orgCode,
        tyreStatusInputList: [
          {
            status: 1,
            tyreCode: row.tyreCode
          }
        ]
      }
    });
    this.$message.success("取消成功");
    this.getData();
  }
  async cancelRecord(row) {
    await this.$confirm("你确定取消吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
    await this.updateStoreRecordStatus({
      scanStoreUpdateInput: {
        recordCode: row.recordCode,
        orgCode: row.orgCode,
        tyreStatusInputList: [
          {
            status: 3,
            tyreCode: row.tyreCode
          }
        ]
      }
    });
    row.status = 0;
    this.$message.success("取消成功");
  }

  /**
   * 根据条件判断
   * logo：K2编码、胎号、入库状态、市场类型 都为空时，值为2，非则为1
   *  recordCode: "",
      tyreCode: "",
      marketType: "",
      status: undefined,
      updateDateTime: "",
      time: "",
      recordType: 2
   */
  async exportExcelFn() {
    await this.timeLimitFn();
    const { searchParams: input } = this;
    const {
      updateStartTime,
      updateEndTime,
      recordCode,
      tyreCode,
      marketType,
      status
    } = input;
    if (updateStartTime && updateEndTime) {
      let logo = "1";
      if (recordCode || tyreCode || marketType || status) {
        logo = "1";
      } else {
        logo = "2";
      }
      await this.exportStoreScanRecordByUpdateTime({
        input,
        logo
      });
    } else {
      await this.exportStoreScanRecord({
        input
      });
    }
  }
  async timeLimitFn() {
    return new Promise((resolve, reject) => {
      const { searchParams: input } = this;
      const {
        orgCode,
        tyreCode,
        ownerMobile,
        startTime,
        updateStartTime
      } = input;
      if (
        !(orgCode || tyreCode || ownerMobile) &&
        !startTime &&
        !updateStartTime
      ) {
        this.$message.warning("请选择入库时间或更新时间！");
        reject(false);
        return false;
      } else {
        resolve(true);
        return true;
      }
    });
  }
}
